import { useEffect, useState } from "react";
import { useTheme } from "../useTheme";
import { useWindowWidth } from "./useWindowWidth";
export const useReactiveThemeProperty = (property) => {
    const width = useWindowWidth();
    const { reactiveProperties } = useTheme();
    const [value, setValue] = useState();
    useEffect(() => {
        const prop = reactiveProperties && reactiveProperties[property];
        if (prop) {
            const keys = Object.keys(prop).map(k => parseInt(k, 10));
            keys.sort((a, b) => a > b ? -1 : 1);
            for (let p of keys) {
                if (width >= p) {
                    setValue(prop[p]);
                    break;
                }
            }
        }
    }, [
        !!reactiveProperties,
        width,
        property,
    ]);
    return value;
};
//# sourceMappingURL=useReactiveThemeProperty.js.map